// extracted by mini-css-extract-plugin
export default {"wrapper":"Ml-z","viewport":"Nl-z","container":"Ol-z","slide":"Pl-z"};